module.exports = __webpack_public_path__ + "files/lamy.eeec84132ecc1b998480528f5290c0a8.pdf";